import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {TrackingRoutingModule} from './tracking-routing.module';
import {TrackingComponent} from './tracking.component';
import {TrackOrderComponent} from './track-order/track-order.component';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {SharedModule} from 'src/app/shared/shared.module';
import {ShippingModule} from '../shipping/shipping.module';
import {FindOrdersComponent} from './find-orders/find-orders.component';
import {OrderRowComponent} from './order-row/order-row.component';
import {RECAPTCHA_LANGUAGE, RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module} from 'ng-recaptcha';


export function CaptchaLangFactory(translateService: TranslateService): string {
  return translateService.currentLang;
}


export function  useCaptcha(): string {
  // @ts-ignore
  return localStorage.getItem('recapca');
}




@NgModule({
  declarations: [
    TrackingComponent,
    TrackOrderComponent,
    FindOrdersComponent,
    OrderRowComponent
  ],
  imports: [
    CommonModule,
    TrackingRoutingModule,
    TranslateModule,
    SharedModule,
    ShippingModule,

  ],
  providers: [
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: useCaptcha()},
    {
      provide: RECAPTCHA_LANGUAGE, useFactory: CaptchaLangFactory,
      deps: [TranslateService]
    },
  ],
  exports : [
  ]

})
export class TrackingModule { }

// (appConfig: AppConfigService) => () => appConfig.appConfig.RECAPTCHA_KEY, deps: [AppConfigService], multi: true
